export default __webpack_public_path__ + "static/Plimpton-ab24209efea0f2fb37be72a04eced4f5.jpg";